/**
 * Copyright (C) 2017-, Optio3, Inc. All Rights Reserved.
 *
 * Proprietary & Confidential Information.
 *
 * CoreStack External API
 * No description provided (generated by Swagger Codegen https://github.com/swagger-api/swagger-codegen)
 *
 * OpenAPI spec version: 1.0.0
 *
 *
 * NOTE: This class is auto generated by the swagger code generator program.
 * https://github.com/swagger-api/swagger-codegen.git
 * Do not edit the class manually.
 */

import * as models from './models';

export class ReportConfiguration {
    __type: string;

    protected setDiscriminator(type: string) {
        this.__type = type;
    }

    getFixupPrototypeFunction() { return ReportConfiguration.fixupPrototype; }

    static newInstance(model: Partial<ReportConfiguration>): ReportConfiguration {
        let obj = Object.assign(new ReportConfiguration(), model);
        ReportConfiguration.fixupPrototype(obj);
        return obj;
    }

    static deepClone(model: Partial<ReportConfiguration>): ReportConfiguration {
        if (!model) return null;
        return ReportConfiguration.newInstance(<ReportConfiguration> JSON.parse(JSON.stringify(model)));
    }

    static fixupPrototype(obj: ReportConfiguration) {
        if (!obj) return;

        models.ReportConfiguration.setPrototype(obj);

        obj.fixupFields();
    }

    protected static setPrototype(obj: ReportConfiguration): boolean {
        switch (obj.__type)
        {
            case "BaseReportConfigurationForAiAgentArtifact":
                Object.setPrototypeOf(obj, models.BaseReportConfigurationForAiAgentArtifact.prototype);
                break;
            case "BaseReportConfigurationForAssessmentAgent":
                Object.setPrototypeOf(obj, models.BaseReportConfigurationForAssessmentAgent.prototype);
                break;
            case "ConfigurationForAwsConsolidatedChargesReport":
                Object.setPrototypeOf(obj, models.ConfigurationForAwsConsolidatedChargesReport.prototype);
                break;
            case "ConfigurationForAzureConsolidatedChargesReport":
                Object.setPrototypeOf(obj, models.ConfigurationForAzureConsolidatedChargesReport.prototype);
                break;
            case "ConfigurationForDistributorConsolidatedReport":
                Object.setPrototypeOf(obj, models.ConfigurationForDistributorConsolidatedReport.prototype);
                break;
            case "ConfigurationForFinOpsConsolidatedReport":
                Object.setPrototypeOf(obj, models.ConfigurationForFinOpsConsolidatedReport.prototype);
                break;
            case "ConfigurationForGcpConsolidatedChargesReport":
                Object.setPrototypeOf(obj, models.ConfigurationForGcpConsolidatedChargesReport.prototype);
                break;
            case "ConfigurationForNextGenReportBase":
                Object.setPrototypeOf(obj, models.ConfigurationForNextGenReportBase.prototype);
                break;
            case "ConfigurationForOciConsolidatedChargesReport":
                Object.setPrototypeOf(obj, models.ConfigurationForOciConsolidatedChargesReport.prototype);
                break;
            case "ReportConfigurationForAiAgent":
                Object.setPrototypeOf(obj, models.ReportConfigurationForAiAgent.prototype);
                break;
            case "ReportConfigurationForAssessment":
                Object.setPrototypeOf(obj, models.ReportConfigurationForAssessment.prototype);
                break;
            case "ReportConfigurationForAssessmentRun":
                Object.setPrototypeOf(obj, models.ReportConfigurationForAssessmentRun.prototype);
                break;
            case "ReportConfigurationForAssessmentRunDetail":
                Object.setPrototypeOf(obj, models.ReportConfigurationForAssessmentRunDetail.prototype);
                break;
            case "ReportConfigurationForAssessmentRunSummary":
                Object.setPrototypeOf(obj, models.ReportConfigurationForAssessmentRunSummary.prototype);
                break;
            case "ReportConfigurationForAssessmentRunViolation":
                Object.setPrototypeOf(obj, models.ReportConfigurationForAssessmentRunViolation.prototype);
                break;
            case "ReportConfigurationForExecutiveDashboard":
                Object.setPrototypeOf(obj, models.ReportConfigurationForExecutiveDashboard.prototype);
                break;
            case "ReportConfigurationForWorkload":
                Object.setPrototypeOf(obj, models.ReportConfigurationForWorkload.prototype);
                break;
        }
        return true; // Tell the caller this is a polymorphic type, it should not overwrite the prototype.
    }

    static getTypeHierarchy(): (typeof ReportConfiguration)[] {
        return [
            models.BaseReportConfigurationForAiAgentArtifact,
            models.BaseReportConfigurationForAssessmentAgent,
            models.ConfigurationForAwsConsolidatedChargesReport,
            models.ConfigurationForAzureConsolidatedChargesReport,
            models.ConfigurationForDistributorConsolidatedReport,
            models.ConfigurationForFinOpsConsolidatedReport,
            models.ConfigurationForGcpConsolidatedChargesReport,
            models.ConfigurationForNextGenReportBase,
            models.ConfigurationForOciConsolidatedChargesReport,
            models.ReportConfigurationForAiAgent,
            models.ReportConfigurationForAssessment,
            models.ReportConfigurationForAssessmentRun,
            models.ReportConfigurationForAssessmentRunDetail,
            models.ReportConfigurationForAssessmentRunSummary,
            models.ReportConfigurationForAssessmentRunViolation,
            models.ReportConfigurationForExecutiveDashboard,
            models.ReportConfigurationForWorkload,
        ];
    }

    fixupFields() {
    }

    /**
     * Specifies the format of the file being exported.
     */
    export_format: models.ExportFormat;

}
